/* eslint-disable */

/** A customer's eligibility status to a Crypto feature */
export enum CryptoEligibilityStatus {
  ELIGIBILITY_STATUS_UNSPECIFIED = "ELIGIBILITY_STATUS_UNSPECIFIED",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  CAN_BE_ELIGIBLE = "CAN_BE_ELIGIBLE",
  ELIGIBLE = "ELIGIBLE",
  INELIGIBLE = "INELIGIBLE",
}

export interface CryptoEligibilities {
  /** The customer's Bitcoin p2p send eligibility status */
  btc_p2p_send?: CryptoEligibilityStatus;
  /** The customer's Bitcoin p2p receive eligibility status */
  btc_p2p_receive?: CryptoEligibilityStatus;
  /** The customer's Bitcoin withdrawals eligibility status */
  btc_withdraw?: CryptoEligibilityStatus;
  /** The customer's Bitcoin deposits eligibility status */
  btc_deposit?: CryptoEligibilityStatus;
  /** The customer's Bitcoin lightning withdrawals eligibility status */
  btc_lightning_withdraw?: CryptoEligibilityStatus;
  /** The customer's Bitcoin lightning deposits eligibility status */
  btc_lightning_deposit?: CryptoEligibilityStatus;
}
